import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=8ca047ce&scoped=true"
import script from "./ResetEmail.vue?vue&type=script&lang=js"
export * from "./ResetEmail.vue?vue&type=script&lang=js"
import style0 from "./ResetEmail.vue?vue&type=style&index=0&id=8ca047ce&prod&scoped=true&lang=css"
import style1 from "./ResetEmail.vue?vue&type=style&index=1&id=8ca047ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca047ce",
  null
  
)

export default component.exports